import axios from '../utils/axios';

export default function getLeadsCSV(adminId, params) {
    
    return (
        axios.get('/admin/' + adminId + '/getLeadsCsv', { params })
    )
}
